import type { Action, Reducer } from 'umi';

export interface IReportRecognizeResult {
  file: File | null;
  result: any | null;
}

export interface IReportDataState {
  recognizeResult: IReportRecognizeResult | null;
}

type IUpdateReportRecognizeResultAction = Action<'updateReportRecognizeResult'> & {
  type: string;
  payload: IReportRecognizeResult;
};

export interface IReportDataModel {
  namespace: string;
  state: IReportDataState;
  effects: {};
  reducers: {
    updateReportRecognizeResult: Reducer<IReportDataState, IUpdateReportRecognizeResultAction>;
  };
}

export const REPORT_DATA_MODEL_NAMESPACE = 'dbh-model-report-data';

export const DEFAULT_REPORT_RECOGNIZE_RESULT: IReportRecognizeResult | null = null;

export const DEFAULT_REPORT_DATA_STATE: IReportDataState = {
  recognizeResult: DEFAULT_REPORT_RECOGNIZE_RESULT,
};

const ReportDataModel: IReportDataModel = {
  namespace: REPORT_DATA_MODEL_NAMESPACE,
  state: DEFAULT_REPORT_DATA_STATE,
  effects: {},
  reducers: {
    updateReportRecognizeResult(state, action) {
      return { ...state, recognizeResult: action?.payload || DEFAULT_REPORT_RECOGNIZE_RESULT };
    },
  },
};

export default ReportDataModel;
